<template>
    <div id="" :class="tall ? 'webinar-tall': ''" class="webinar content-box">
        <div class="content">
            <img src="../assets/img/lasso_x_small_white_logo.png" />
            <h5>Gratis webinar</h5>
            <h4>Få tid til at sælge igen<br>med 4 digitale tools</h4>
            <a href="https://lassox.com/webinar?utm_campaign=Webinarer%202023&utm_source=lasso.dk&utm_medium=lasso.dk%20banner" target="_blank">
                <img class="webinar-button plausible-event-name=webinar+click" src="../assets/img/webinar-button-green.png" />
            </a>
            <div class="time-date">
                <p><img src="../assets/img/calendar_icon.png" />Tirsdag d. 13 juni</p>
                <p><img src="../assets/img/clock_icon.png" />kl. 10:00-11:00</p>
            </div>
        </div>
        <div class="person-role">
            <p>med Kristine Lindorff<br>Client Manager B2B-salg</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tall: {
            type: Boolean,
            default: false
        }
    },
    computed: {

    }
}
</script>

<style lang="less">
    .webinar {
        position: relative;
        display: flex;
        justify-content: space-between;
        background-image: url(../assets/img/webinar_tall_kristine.png);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center top;
        min-height: 400px;

        .content {
            color: #fff;
            padding: 30px 0 30px 30px;

            h5 {
                font-size: 26px;
                font-weight: 500;
                line-height: 32px;
                // color: #9686f3;
                color: #b9fbc3;
                margin: 0;
            }

            h4 {
                font-size: 28px;
                font-weight: 500;
                line-height: 35px;
                margin: 5px 0 15px 0;
            }

            p {
                font-size: 15px;
                font-weight: 500;
                line-height: 25px;
                margin: 5px 0 15px 0;
            }

            .webinar-button {
                height: 40px;
                margin: 0;
            }
        }

        .time-date {
            margin-top: 10px;
            display: flex;
            color: #352648;
            img {
                height: 14px;
                position: relative;
                top: 1px;
                margin-right: 5px;
            }

            p:last-child {
                margin-left: 10px;
            }

        }

        .person-role {
            display: none;
        }

        @media only screen and (min-width: 450px) {
            background-position: center -30px;
        }

        @media only screen and (min-width: 450px) {
            background-position: center -60px;
        }


        @media only screen and (min-width: 500px) {
            min-height: 450px;
            background-position: center -60px;
        }

        @media only screen and (min-width: 550px) {
            min-height: 450px;
            background-position: center -100px;
        }

        @media only screen and (min-width: 640px) {
            background-image: url(../assets/img/webinar_wide_kristine.png);
            background-position: 80% 0;
            justify-content: space-between;
            min-height: 340px;
            .content {
                max-width: 320px;
                // margin-left: 30px;
            }
        }


        @media only screen and (min-width: 860px) {
            background-position: right;
            .time-date {
                color: #352648;
            }

            .person-role {
                margin-right: 270px;
                display: flex;
                align-items: flex-end;
                padding-bottom: 15px;
                color: white;
            }
        }

        @media only screen and (min-width: 1024px) {
            padding: 0 30px;
        }
    }
</style>
